var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"expand-table"},[_c('Table',{attrs:{"show-header":false,"stripe":true,"border":false,"columns":_vm.row.list.columns,"data":_vm.row.list.data || [],"no-data-text":_vm.row.list.noDataText ? _vm.row.list.noDataText : '亲，没有找到相关记录哦！~'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }